/* ══════════════════════════════════════════════════════════════════════
   Tree-shaken ECharts registration. Import `echarts` and the SN theme
   name from THIS module — never from 'echarts' (the full bundle).
   API confirmed against ECharts 5 tree-shaking docs.
   ══════════════════════════════════════════════════════════════════════ */
import * as echarts from 'echarts/core';
import { LineChart, BarChart, PieChart, RadarChart, GaugeChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
  RadarComponent,
} from 'echarts/components';
import { SVGRenderer } from 'echarts/renderers';
import { snEchartsTheme, SN_ECHARTS_THEME } from './snEchartsTheme';

echarts.use([
  LineChart,
  BarChart,
  PieChart,
  RadarChart,
  GaugeChart,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  RadarComponent,
  SVGRenderer,
]);

echarts.registerTheme(SN_ECHARTS_THEME, snEchartsTheme);

export { echarts, SN_ECHARTS_THEME };
